import React, { ReactNode } from 'react';
import styled, { css, keyframes } from 'styled-components';
import axios from 'axios';
import ReactGA from 'react-ga';

import { element } from 'prop-types';
import { tabResultState } from '../../../../modules/tabResult';
import FindURL from '../../common/FindURL';
import config from '../../../../lib/config-api.json';
import { media } from '../../../common/Layout';
import {
  ItemContainer,
  ItemDescBox,
  ItemSourceBox,
  ItemTitleBox,
} from '../../common/Layout';
import { PostConsumptionBodyType } from '../../../../lib/common/type';

const env = process.env.NODE_ENV;
let { apiInfo } = config;

if (env === 'development') {
  apiInfo = config.apiInfo_dev;
}

const SearchListContainter = styled.div`
  width: 100%;
`;

type SearchListProps = {
  limitList: number;
  travel_info?: tabResultState['travel_info'];
  recommended_info?: tabResultState['recommended_info'];
  course_info?: tabResultState['course_info'];
  attachResult? : tabResultState['attachResult']; //헷갈림
  onPostConsumption: (info: PostConsumptionBodyType) => void;
};

type SearchListState = {};

class SearchList extends React.PureComponent<SearchListProps, SearchListState> {
  ConsumtionContent = (id: number, targetId: number) => {
    const { onPostConsumption } = this.props;
    let targets = 'travel_info';
    switch (targetId) {
      case 0:
        targets = 'travel_info';
        break;
      case 1:
        targets = 'recommended_info';
        break;
      case 2:
        targets = 'course_info';
        break;
      case 3:
        targets = 'attachResult'; //헷갈림
        break;
      default:
        break;
    }
    ReactGA.ga('send', 'event', `click_search_result_normal_contents`);
    const data = {
      primary_key: id,
      target: targets,
      document_type: 'normal',
      session: localStorage.getItem('aivory_session_id') || 'test_session',
      reaction_type: 0,
      read_type: 0,
    };
    const newData = {
      primary_key: id,
      target: targets,
      document_type: 'normal',
      read_type: 0,
    };
    onPostConsumption(newData);
    axios({
      method: 'post',
      url: `${apiInfo.api_url}/read/`,
      timeout: 10000,
      data,
    });
  };

  contentFrame = (
    source: string,
    url: string,
    id: number,
    targetId: number,
    location_depth_1: string,
    location_depth_2: string,
    title?: string,
    content?: string,
    highlightTitle?: string,
    highlightContent?: string
  ): ReactNode | null => {
    const resultReactNode = (
      <ItemContainer>
        {highlightTitle ? (
          <ItemTitleBox
            href={url}
            target="_blank"
            dangerouslySetInnerHTML={{
              __html: highlightTitle,
            }}
            onClick={() => {
              this.ConsumtionContent(id, targetId);
            }}
          />
        ) : (
          <ItemTitleBox href={url} target="_blank">
            {title}
          </ItemTitleBox>
        )}

        {highlightContent ? (
          <ItemDescBox
            dangerouslySetInnerHTML={{
              __html: highlightContent,
            }}
          />
        ) : (
          <ItemDescBox>{content}</ItemDescBox>
        )}

        <ItemSourceBox>
          {`${location_depth_1} `}
          {location_depth_2}
        </ItemSourceBox>
      </ItemContainer>
    );

    return resultReactNode;
  };

  makeList = (): ReactNode[] | null => {
    const {
      limitList,
      course_info,
      recommended_info,
      travel_info,
      attachResult, //헷갈림
    } = this.props;
    const resultReactNode: ReactNode[] | null = [];
    if (travel_info && travel_info.results) {
      travel_info.results.forEach((element, index) => {
        if (index > limitList - 1) {
          return resultReactNode;
        }
        const urlInfo = FindURL(element.cot_id, 0);
        resultReactNode.push(
          this.contentFrame(
            urlInfo.source,
            urlInfo.url,
            element.id,
            0,
            element.location_depth_1,
            element.location_depth_2,
            element.title,
            element.content,
            element.highlight.title?.[0] || undefined,
            element.highlight.content?.[0] || undefined
          )
        );
        return false;
      });
    } else if (recommended_info && recommended_info.results) {
      recommended_info.results.forEach((element, index) => {
        if (index > limitList - 1) {
          return resultReactNode;
        }
        const urlInfo = FindURL(element.cot_id, 1);
        resultReactNode.push(
          this.contentFrame(
            urlInfo.source,
            urlInfo.url,
            element.id,
            1,
            element.location_depth_1,
            element.location_depth_2,
            element.title,
            element.content,
            element.highlight.title?.[0] || undefined,
            element.highlight.content?.[0] || undefined
          )
        );
        return false;
      });
    } else if (course_info && course_info.results && course_info.total > 0) {
      course_info.results.forEach((element, index) => {
        if (index > limitList - 1) {
          return resultReactNode;
        }

        const urlInfo = FindURL(element.cot_id, 2);
        resultReactNode.push(
          this.contentFrame(
            urlInfo.source,
            urlInfo.url,
            element.id,
            2,
            element.location_depth_1,
            element.location_depth_2,
            element.title,
            element.content,
            element.highlight.title?.[0] || undefined,
            element.highlight.content?.[0] || undefined
          )
        );
        return false;
      });
      
      
    }else if (attachResult && attachResult.results && attachResult.total > 0) {
      attachResult.results.forEach((element, index) => {
        if (index > limitList - 1) {
          return resultReactNode;
        }

        // const urlInfo = FindURL(element.cot_id, 2);
        resultReactNode.push(
          this.contentFrame(
            '',
            element.download_url,
            0,
            3,
            '',
            '',
            element.name,
            element.normalized_text,
            undefined,
            undefined
          )
        );
        console.log("attachResult "+ attachResult.results[0].name);
        // console.log("attachResult a "+ element.atchNm);

        return false;
      });
    }


    return resultReactNode;
  };

  render() {
    return <SearchListContainter>{this.makeList()}</SearchListContainter>;
  }
}

export default SearchList;
